import { Box, Input, makeStyles } from '@material-ui/core';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootState, useSelector } from 'src/store';
import Edit from 'src/components/Icon/Edit';
import Check from 'src/components/Icon/Check';
import { editTracking } from 'src/store/modules/trackings';

const useStyles = makeStyles(() => ({
  tracking: {
    minWidth: '224px',
    maxWidth: '224px',
    minHeight: '36px',
    maxHeight: '36px',
    display: 'flex',
    alignItems: 'center'
  },

  input: {
    maxWidth: '180px',
    minHeight: '36px',
    maxHeight: '36px',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    color: '#191F28'
  },
  edit: {
    minWidth: '200px',
    maxWidth: '200px',
    minHeight: '36px',
    maxHeight: '36px',
    padding: '8px 12px',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    border: '1px solid #191F28',
    borderRadius: '8px',
    background: '#FFFFFF',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#F7F8FA'
    }
  },
  editIcon: {
    minWidth: 18,
    maxWidth: 18,
    minHeight: 18,
    maxHeight: 18,
    cursor: 'pointer',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.7
    }
  },

  line: {
    width: '100%',
    maxHeight: 1,
    border: '1px dashed #191F28'
  }
}));

const TrackingEdit = ({ value, type, idx = -1 }: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const [text, setText] = useState(value || '');
  const [focus, setFocus] = useState(false);

  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const [key, setKey] = useState(false);

  const handleChangeText = e => {
    e.preventDefault();
    let newTracking = {};
    if (idx === -1) {
      const newTrackings = tracking?.[type]?.slice();
      if (typeof text === 'string') {
        newTrackings.splice(currentIndex, 1, text.split('\n').join('\\n'));
      }
      newTracking = JSON.parse(
        `{"${type}": [${newTrackings?.map((_: any, idx: number) => {
          const newT = newTrackings?.[idx];
          return `"${newT}"`;
        })}]}`
      );
    } else {
      const newTrackingJson = tracking?.[type]?.slice();
      const newTrackingArray = tracking?.[type]?.[currentIndex]?.slice();
      if (typeof text === 'string') {
        newTrackingArray.splice(idx, 1, text.split('\n').join('\\n'));
      }
      newTrackingJson.splice(currentIndex, 1, newTrackingArray);
      newTracking = JSON.parse(
        `{"${type}": [${newTrackingJson?.map(
          (trackings: any, idx: number) =>
            `[${trackings?.map(
              (tracking: any, idx2: number) => `"${tracking}"`
            )}]`
        )}]}`
      );
    }
    dispatch(editTracking({ ...tracking, ...newTracking }));
  };
  const handleClickEdit = () => {
    setFocus(true);
    inputRef.current.focus();
  };

  const handleChange = e => {
    const textSplit = e.target.value.split('');
    if (e.target.value.length > 20) return;
    if (textSplit[textSplit.length - 1] === "'") return;
    if (textSplit[textSplit.length - 1] === '"') return;

    setText(e.target.value);
  };
  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      setKey(true);
      setFocus(false);
      handleChangeText(e);
      inputRef.current.blur();
    }
  };
  useEffect(() => {
    setText(value ?? '');
  }, [value]);

  return (
    <Box className={classes.tracking}>
      <Box className={classes.edit}>
        <Input
          ref={inputRef}
          className={classes.input}
          value={text}
          color="primary"
          onClick={() => {
            setFocus(true);
          }}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          onBlur={e => {
            if (focus) {
              handleChangeText(e);
              setFocus(false);
              setText(value);
              setKey(true);
            }
          }}
          disableUnderline
        />
        <div
          tabIndex={0}
          className={classes.editIcon}
          onClick={
            e => (focus ? handleChangeText(e) : handleClickEdit())
            //   () => {
            //   console.log('test ' + focus);
            //   if (focus) handleChangeText();
            //   else handleClickEdit();
            // }
          }
        >
          {focus ? <Check /> : <Edit />}
        </div>
      </Box>
      <Box className={classes.line} />
    </Box>
  );
};

export default TrackingEdit;
